import React from 'react'
import Helmet from 'react-helmet'
import { Link, graphql } from 'gatsby'
import Layout from '../layouts/index';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import SEO from '../components/SEO';
import { PATHS } from '../utils/urls';

const _ = require('lodash');
const title = "Blog"

class categoryRoute extends React.Component {

  render() {
    const postsPerPage = this.props.pageContext.limit;
    const numberOfPosts = this.props.data.allMarkdownRemark.totalCount;
    const numPages = Math.ceil(numberOfPosts / postsPerPage);

    const location = this.props.pageContext.category;
    const categoryPath = `category/${_.kebabCase(location)}/`;

    const posts = this.props.data.allMarkdownRemark.edges
    const category = this.props.pageContext.category

    const categories = this.props.data.allCategoriesJson.edges;
    // console.log("Categories! ", categories);
    const foundcategory = categories.filter(
      cat => cat.node.name === category
    );
    // console.log(foundcategory);
    const categorie_desc = foundcategory.map(cat => (
      cat.node.description
    ))
    // console.log("foundcategory", foundcategory[0].node.description);


    const postLinks = posts.map(post => (
    
      
      <div className="blogCards" key={post.node.frontmatter.path}>
        <a target="_blank" href={post.node.frontmatter.path}  >
          <div>
            <img src={post.node.frontmatter.featuredimage} alt={post.node.frontmatter.title} />
          </div>
          <div className="sectionSpacing">
            <p className="blogTaxonomy text-decoration-none">{category}</p>
            <p>{post.node.frontmatter.title}</p>
            <p>{post.node.frontmatter.postsummary}</p>

          </div>
        </a>
      </div>
    ))



    return (
      <Layout>
        <SEO title={`${category} | ${title} | ChartHop`} /> 
        <Helmet>
          <meta
            name="description"
            content={foundcategory[0].node.description}
          />
          <meta property="og:url" content={`https://www.charthop.com/blog${categoryPath}`} />
          <meta property="og:title" content={`${category} | ${title} | ChartHop`} />
          <meta property="og:description" content={foundcategory[0].node.seodescription} />
          <meta property="og:image" content={foundcategory[0].node.shareImage} />
          <meta property="og:type" content="website" />
          {console.log("foundcategory[0].node.shareImage", foundcategory[0].node.shareImage)}

          {/* Twitter Card tags */}
          <meta name="twitter:title" content={`${category} | ${title} | ChartHop`} />
          <meta name="twitter:description" content={foundcategory[0].node.seodescription} />
          <meta name="twitter:image" content={foundcategory[0].node.shareImage} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        {/* LATEST POSTS */}
        <section className="sectionSpacing">
          <section className="d-flex flex-column contentBlock">
            <div>
              <p className="blogTaxonomy text-center"><Link className="categoryLink" to={PATHS.BLOG} >Blog</Link></p>
              <h1 className="text-center">{category}</h1>
              <p className="text-center compressedTitle mx-auto header-p mb-0">{categorie_desc}</p>
            </div>
          </section>
        </section>

        {/* POST CONTENT */}
        <section className="sectionSpacing backgroundGradientContainer-Reverse">
          <h2 className="text-center">{category}</h2>

          <div className="blogCardWrapper">
            {postLinks}
          </div>
          {numPages > 1 &&
            <div id="myDIV" className="d-flex sectionSpacing  pb-0 justify-content-center pagination">
              {Array.from({ length: numPages }, (_, i) => (
                <Link key={`pagination-number${i + 1}`} className="toggle-me" to={`/blog/${categoryPath}/${i === 0 ? "" : i + 1}`} >
                  <p>{i + 1}</p>
                </Link>
              ))}
            </div>
          }

        </section>

        {/* LONG FORM */}
        <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
          <DemoFormLong source={_.kebabCase(category) + '-demo-bottom'} headertext={HtmlParser("<h1>See it in action!</br></br> Request a demo now.</h1>")} focusID={HtmlParser("name")} />
        </section>

      </Layout >
    )
  }
}

export default categoryRoute

export const categoryPageQuery = graphql`
  query categoryPage($category: String, $skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      skip: $skip
      limit: $limit
      filter: { frontmatter: { categories: { in: [$category] } } }

    ) {
      totalCount
      edges {
        node {
          
          frontmatter {
            title
            path
            postsummary
            featuredimage
            categories
          }
        }
      }
    },
    allCategoriesJson {
      edges {
        node {
          id
          name
          description
          seodescription
          shareImage
        }
      }
    }
  }
`
